import { render } from "./LoadGameView.vue?vue&type=template&id=3b9ae82e"
import script from "./LoadGameView.vue?vue&type=script&lang=js"
export * from "./LoadGameView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__